class HeaderSearch extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector("[data-toggle]");

    this.formInput = this.querySelector('[name="q"]');
    this.content = this.querySelector(".header-search__content");
    this.searchForm = this.querySelector("header-search-form");

    this.toggle.addEventListener("click", () => {
      if (this.hasAttribute("open")) {
        this._close();
      } else {
        this._open();
      }
    });

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.hasAttribute("open")) {
        this._close();
      }
    };
  }

  connectedCallback() {
    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
  }

  _open() {
    if (this.hasAttribute("open")) return;

    this.searchForm.style.display = null;
    this.style.overflow = "hidden";

    this.onEnd = () => {
      this.content.removeEventListener("transitionend", this.onEnd);
      this.searchForm.dispatchEvent(
        new CustomEvent("header-search-form:focus"),
      );
      this.style.overflow = null;
    };

    this.content.addEventListener("transitionend", this.onEnd);

    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      this.toggle.setAttribute("aria-expanded", "true");
    });
  }

  _close() {
    if (!this.hasAttribute("open")) return;

    this.onEnd = () => {
      this.content.removeEventListener("transitionend", this.onEnd);
      this.style.overflow = null;
      this.toggle.focus();
      this.searchForm.dispatchEvent(
        new CustomEvent("header-search-form:clear"),
      );
      this.searchForm.style.display = "none";
    };

    this.content.addEventListener("transitionend", this.onEnd);

    this.style.overflow = "hidden";
    this.removeAttribute("open");
    this.setAttribute("aria-expanded", "false");
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
